import { Pipe, PipeTransform } from '@angular/core';
import { HelperFunctions } from '../../../../utils/helper.functions';
import { AuthService } from '../../../../global/services/auth.service';
import { Currency } from '../../../../global/enums/Currency';
import { DistanceUnit } from '../../../../global/enums/DistanceUnit';

@Pipe({
  name: 'bucksPerDistancePipe',
})
export class BucksPerDistancePipe implements PipeTransform {
  constructor(private helperFunctions: HelperFunctions, private authService: AuthService) {}
  transform(price?: number, currency?: Currency | string, distance?: number): string {
    const preferredDistanceUnit = this.authService.getDistanceUnit();
    const formatedDistance =
      preferredDistanceUnit === DistanceUnit.mile
        ? this.helperFunctions.metersToMiles(distance)
        : this.helperFunctions.metersToKM(distance);
    const priceFloat = formatedDistance > 0 ? parseFloat((price / formatedDistance).toFixed(1)) : 0;
    return `${currency} ${priceFloat} per ${preferredDistanceUnit}`;
  }
}
